import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Create Candidate Service*/
const createCandidate = (params) => {
  const param ={
    type:"upload"
  }
  const { axiosInstance,config } = getAxiosConfig(param);
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.candidate.createCandidate}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Create Candidate Service*/
const updateCandidateDetails = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.candidate.updateCandidateDetails}`,
    method: "PUT",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Get Candidate Service*/
const getAllCandidate = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.candidate.getAllCandidates}`,
      method: "POST",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


export default {
    createCandidate,
    getAllCandidate,
    updateCandidateDetails
    
}